module.exports = __webpack_public_path__ + "static/media/中2学年展示.6ce1d501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中2学年展示.png
// module id = 307
// module chunks = 10